import { ActionReducerMapBuilder, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppContext } from '../components/Menu/app-context';
import { login, LoginResponse } from './user/login.handler';

export enum YMState {
    Unknown = 0,
    Ready = 1,
    Fail = 2
}

export enum TAdv {
    None = '',
    Draw = '1',
    Game = '2',
}

export const advConv = (value: string): TAdv => {
    for (const enumValue of Object.values(TAdv))
        if (enumValue === value)
            return enumValue;

    return TAdv.None;
}

export interface IAppState {
    yclid: string;
    ref: string;
    adv: TAdv;
    clientId: string;
    clientIdSent: boolean;
    inited: boolean;

    ymState: YMState;
    modal: string;
    context: AppContext;
}

const initialState: IAppState = {
    yclid: '',
    ref: '',
    adv: TAdv.None,
    clientId: '',
    clientIdSent: false,
    inited: false,

    ymState: YMState.Unknown,
    modal: "",
    context: AppContext.None,
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setAppContext: (state: IAppState, action: PayloadAction<AppContext>) => {
            state.context = action.payload;
        },
        setAppParams: (state: IAppState, action: PayloadAction<Pick<IAppState, 'yclid' | 'ref' | 'adv'>>) => {
            state.yclid = action.payload.yclid;
            state.ref = action.payload.ref;
            state.adv = action.payload.adv;
            state.inited = true;
        },
        setClientId: (state: IAppState, action: PayloadAction<string>) => {
            state.clientId = action.payload;
        },
        setClientIdSent: (state: IAppState, action: PayloadAction<boolean>) => {
            state.clientIdSent = action.payload;
        },
        setYMState: (state: IAppState, action: PayloadAction<YMState>) => {
            state.ymState = action.payload;
        },
        setModalName: (state: IAppState, action: PayloadAction<string>) => {
            state.modal = action.payload;
        },
    },
    extraReducers: (builder: ActionReducerMapBuilder<IAppState>) => {
        builder.addCase(login.fulfilled, (state: IAppState, action: PayloadAction<LoginResponse>) => {
            const backendYclid = action.payload.user.yclid;
            if (!state.yclid && backendYclid)
                state.yclid = backendYclid;
        });
    },
});

export const { setAppContext, setAppParams, setClientId, setClientIdSent, setYMState, setModalName } = appSlice.actions;
export default appSlice.reducer;
